import React, { useEffect, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import { WithApp } from 'contexts/appContext';
import moment from 'moment';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import { wsGetAll, wsFindBy } from 'services/WService';
import { Autocomplete } from '@material-ui/lab';

export default WithApp(function ModalIndicatorsClorox(props) {
  const indicador = props.model;
  const periodo = moment(indicador.valueSearch?.Periodo).format('YYYY-MM');
  const [dataChanging, setDataChanging] = useState({});
  const [zones, setZones] = useState([]);
  const [groups, setGroups] = useState([]);

  function handleChange(field, value) {
    setDataChanging((prev) => ({ ...prev, [field]: value }));
  }

  async function listZones() {
    let response = await wsGetAll('base/zone');
    if (response.success) {
      const uniqueZones = response.data.filter((zone, index, arr) => {
        return arr.findIndex((item) => item.defCashier === zone.defCashier) === index;
      });

      const filteredZones = uniqueZones.map(({ defCashier, ...zone }) => zone);
      // "Toda la empresa" = base_zone_id NULL (agrega todas las sedes).
      setZones([{ id: null, description: 'Toda la empresa' }, ...filteredZones]);
    }
  }

  async function listGroups() {
    // Grupos del mismo periodo. Su detalle define los productos con que se calcula el avance.
    let response = await wsFindBy('sale/clorox-group-products', {
      Periodo: periodo,
    });
    if (response.success) setGroups(response.data);
  }

  useEffect(() => {
    if (indicador.open) {
      listZones();
      listGroups();
      // Al editar: null = Toda la empresa; si no, la zona. Al crear: sin seleccion.
      setDataChanging(
        indicador.id
          ? {
              base_zone_id: indicador.base_zone_id != null ? String(indicador.base_zone_id) : null,
              sale_clorox_group_product_id: indicador.sale_clorox_group_product_id ?? null,
            }
          : {},
      );
    }
  }, [indicador.open]);

  return (
    <>
      <Modal
        title={`Indicador Clorox`}
        model={indicador}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity="sale/clorox-indicators"
        dataForce={{
          base_zone_id: dataChanging.base_zone_id,
          sale_clorox_group_product_id: dataChanging.sale_clorox_group_product_id ?? null,
          // type: dataChanging.type,
        }}
      >
        <TextField
          label="Periodo"
          fullWidth
          type="month"
          name="Periodo"
          margin="normal"
          defaultValue={periodo || ''}
          InputLabelProps={{ shrink: true }}
          inputProps={{ readOnly: true }}
          required
        />
        <TextField
          label="Descripción"
          fullWidth
          type="text"
          name="description"
          margin="normal"
          defaultValue={!!indicador ? indicador.description : ''}
          onChange={(e) => handleChange('description', e.target.value)}
          required
        />
        <Autocomplete
          disableClearable
          options={zones}
          getOptionLabel={(item) => `${item.description}`}
          renderInput={(params) => (
            <TextField {...params} label="Zonal" margin="normal" fullWidth />
          )}
          onChange={(e, item) => {handleChange('base_zone_id', item?.id);}}
          value={zones.find((zone) => String(zone.id) === String(dataChanging.base_zone_id)) || null }
          style={{ flexGrow: 1, marginRight: '10px' }}
        />
        <FormControl fullWidth margin="normal" size="small">
          <InputLabel>Tipo</InputLabel>
          <Select
            required
            defaultValue={!!indicador ? indicador.type : ''}
            inputProps={{
              name: 'type',
            }}
          >
            <MenuItem value="I">Compra</MenuItem>
            <MenuItem value="O">Venta</MenuItem>
            <MenuItem value="C">Cobertura</MenuItem>
            <MenuItem value="U">Unidades</MenuItem>
          </Select>
        </FormControl>
        <Autocomplete
          options={groups}
          getOptionLabel={(item) => `${item.description}`}
          renderInput={(params) => (
            <TextField {...params} label="Grupo de productos (opcional)" margin="normal" fullWidth />
          )}
          onChange={(e, item) => { handleChange('sale_clorox_group_product_id', item?.id ?? null); }}
          value={groups.find((g) => String(g.id) === String(dataChanging.sale_clorox_group_product_id)) || null}
          style={{ flexGrow: 1, marginRight: '10px' }}
        />
        <TextField
          label="Cuota"
          fullWidth
          type="number"
          name="quota"
          margin="normal"
          defaultValue={!!indicador ? indicador.quota : ''}
          onChange={(e) => handleChange('quota', e.target.value)}
          required
        />
      </Modal>
    </>
  );
});
